import React from 'react';
import { PropTypes } from 'prop-types';
import { isEmpty, startCase, toLower } from 'lodash';
import formatDuration from 'common/utils/Dates/formatDuration';
import formatSpend from 'common/utils/Money/formatSpend';
import formatShortDate from 'src/common/utils/Dates/formatShortDate';
import { CardDetail } from 'src/common/Card';
import displaySavedClaimCodes from 'src/pages/invoices/utils/displaySavedClaimCodes';

const ScreeningDetails = ({
  invoice,
}) => {
  const procedureCodes = displaySavedClaimCodes(
    invoice.procedure_code?.attributes ? [invoice.procedure_code?.attributes] : [],
  );
  const procedureCodesModifiers = displaySavedClaimCodes(
    invoice.procedure_code_modifiers?.map((pcm) => pcm.attributes),
  );
  const zCodes = displaySavedClaimCodes(invoice.zcodes?.map((zcode) => zcode.attributes));

  return (
    <>
      <CardDetail label="Invoice Unit Amount">
        {invoice.billable_unit_amount}
      </CardDetail>
      <CardDetail label="Rate">
        {formatSpend(invoice.billable_unit_rate, null, true)}
      </CardDetail>
      <CardDetail label="Screening Name">
        {startCase(toLower(invoice.fee_schedule_screening_name))}
      </CardDetail>
      <CardDetail label="Date of Screening">
        {formatShortDate(invoice.procedure_date)}
      </CardDetail>
      <CardDetail label="Screening Duration">
        {invoice.billable_duration ? formatDuration(invoice.billable_duration * 60) : 'N/A'}
      </CardDetail>
      <CardDetail label="Screened By">
        { invoice.provider_employee_name || 'External Screening'}
      </CardDetail>
      {
        !isEmpty(zCodes) ? (
          <CardDetail label="Zcodes">
            { zCodes }
          </CardDetail>
        ) : null
      }
      {
        !isEmpty(procedureCodes) ? (
          <CardDetail label="Procedure Codes">
            { procedureCodes }
          </CardDetail>
        ) : null
      }
      {
        !isEmpty(procedureCodesModifiers) ? (
          <CardDetail label="Procedure Code Modifier">
            { procedureCodesModifiers }
          </CardDetail>
        ) : null
      }
    </>
  );
};

ScreeningDetails.propTypes = {
  invoice: PropTypes.object.isRequired,
};

export default ScreeningDetails;
